import { useCallback, useMemo } from 'react';
import { loadFreshchat } from '@mindtickle/ui-shell-core/Freshchat';
import type { TLocalAuthContext } from '../../Auth';

import useFreshchatHelpers from './useFreshchatHelpers';
import useFreshchatHandlers from './useFreshchatHandlers';
import { isFreshchatConfig } from '../utils';
import { useUserAuth } from '~/components/Auth';

function useFreshchat(auth?: TLocalAuthContext, options?: any) {
  const { tempFeatureConfig = {} } = useUserAuth();
  const helpers = useFreshchatHelpers();
  const name = auth?.user.name;
  const email = auth?.user.email;
  const userId = auth?.user.id;
  const companyId = auth?.company.id;
  const restoreId = auth?.user.freshchatRestoreId;
  const freshchatId = auth?.user.freshchatId;
  const learningSite = auth?.company.learningSite;
  const isFreshchatEnabledForCompany = auth?.featureToggles.isFreshchatEnabled;
  const widgetUuid = tempFeatureConfig?.freshchatWidgetUuid;

  const { eventHandlers, berryEventHandlers } = useFreshchatHandlers({
    auth,
    ...options,
  });

  const { isBerryChatDisabled } = options;
  const config = useMemo(
    () => ({
      name,
      email,
      userId,
      companyId,
      restoreId,
      id: freshchatId,
      learningSite,
      isBerryChatEnabled: !isBerryChatDisabled,
      widgetUuid,
    }),
    [name, email, userId, companyId, restoreId, freshchatId, learningSite, isBerryChatDisabled]
  );

  const init = useCallback(() => {
    if (isFreshchatConfig(config) && isFreshchatEnabledForCompany) {
      loadFreshchat(config, eventHandlers);
    }
  }, [config, eventHandlers, isFreshchatEnabledForCompany]);

  return {
    init: init,
    ...helpers,
    ...berryEventHandlers,
  };
}

export default useFreshchat;
